import { buttonsList } from '../constants';

export const splitButtonsList = (buttons: typeof buttonsList) => {
  const midpoint = Math.floor(buttons.length / 2);
  return {
    topHalf: buttons.slice(0, midpoint),
    bottomHalf: buttons.slice(midpoint),
  };
};
